/* eslint-disable */
export default {
	install (Vue) {
		Vue.prototype.isEmail = function (s) { // 邮箱
			return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
		},
		Vue.prototype.isMobile = function (s) { // 手机号码
			return /^1[0-9]{10}$/.test(s)
		},
		Vue.prototype.isPhone = function (s) { // 电话号码
			return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
		},
		Vue.prototype.isURL = function (s) { // 是否url地址
			return /^http[s]?:\/\/.*/.test(s)
		},
		Vue.prototype.isString = function (o) { // 是否字符串
			return Object.prototype.toString.call(o).slice(8, -1) === 'String'
		},
		Vue.prototype.isNumber = function (o) { // 是否数字
			return Object.prototype.toString.call(o).slice(8, -1) === 'Number'
		},
		Vue.prototype.isBoolean = function (o) { // 是否boolean
			return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean'
		},
		Vue.prototype.isFunction = function (o) { // 是否函数
			return Object.prototype.toString.call(o).slice(8, -1) === 'Function'
		},
		Vue.prototype.isNull = function (o) { // 是否为null
			return Object.prototype.toString.call(o).slice(8, -1) === 'Null'
		},
		Vue.prototype.isUndefined = function (o) { // 是否undefined
			return Object.prototype.toString.call(o).slice(8, -1) === 'Undefined'
		},
		Vue.prototype.isObj = function (o) { // 是否对象
			return Object.prototype.toString.call(o).slice(8, -1) === 'Object'
		},
		Vue.prototype.isArray = function (o) { // 是否数组
			return Object.prototype.toString.call(o).slice(8, -1) === 'Array'
		},
		Vue.prototype.isDate = function (o) { // 是否时间
			return Object.prototype.toString.call(o).slice(8, -1) === 'Date'
		},
		Vue.prototype.getScrollPosition = (el = window) => ({ //获取滚动的坐标
			x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
			y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
		}),
		Vue.prototype.scrollToTop = function () { // 滚动到顶部
			const c = document.documentElement.scrollTop || document.body.scrollTop;
			if (c > 0) {
				window.requestAnimationFrame(scrollToTop);
				window.scrollTo(0, c - c / 8);
			}
		},
		Vue.prototype.contains = function (arr, val) { // 判断一个元素是否在数组中
			return arr.indexOf(val) != -1 ? true : false;
		},
		Vue.prototype.unique = function (arr) { // 数组去重
			if (Array.hasOwnProperty('from')) {
				return Array.from(new Set(arr));
			} else {
				var n = {}, r = [];
				for (var i = 0; i < arr.length; i++) {
					if (!n[arr[i]]) {
						n[arr[i]] = true;
						r.push(arr[i]);
					}
				}
				return r;
			}
		},
		Vue.prototype.union = function (a, b) { // 数组合并
			var newArr = a.concat(b);
			return this.unique(newArr);
		},
		Vue.prototype.intersect = function (a, b) { // 两个数组的交集
			var _this = this;
			a = this.unique(a);
			return this.map(a, function (o) {
				return _this.contains(b, o) ? o : null;
			});
		},
		Vue.prototype.max = function (arr) { // 最大值
			return Math.max.apply(null, arr);
		},
		Vue.prototype.min = function (arr) { // 最小值
			return Math.min.apply(null, arr);
		},
		Vue.prototype.sum = function (arr) { // 求和
			return arr.reduce((pre, cur) => {
				return pre + cur
			})
		}
	}
}